import { Observable } from "core/Misc/observable";
/**
 * A collection of items that can be observed for changes.
 */
export class ObservableCollection {
    constructor() {
        this._items = [];
        this._keys = [];
        this._observable = new Observable();
        this._isDisposed = false;
    }
    /**
     * An observable that notifies observers when the collection changes.
     */
    get observable() {
        return this._observable;
    }
    /**
     * The items in the collection.
     */
    get items() {
        return this._items;
    }
    /**
     * Adds an item to the collection.
     * @param item The item to add.
     * @returns A disposable that removes the item from the collection when disposed.
     */
    add(item) {
        if (this._isDisposed) {
            throw new Error("Observable collection is disposed.");
        }
        const key = Symbol();
        this._items.push(item);
        this._keys.push(key);
        this._observable.notifyObservers();
        return {
            dispose: () => {
                const index = this._keys.indexOf(key);
                if (index === -1) {
                    return;
                }
                this._items.splice(index, 1);
                this._keys.splice(index, 1);
                this._observable.notifyObservers();
            },
        };
    }
    /**
     * Removes all items and observers and rejects subsequent additions.
     */
    dispose() {
        if (this._isDisposed) {
            return;
        }
        this._isDisposed = true;
        this._items.length = 0;
        this._keys.length = 0;
        this._observable.notifyObservers();
        this._observable.clear();
    }
}
//# sourceMappingURL=observableCollection.js.map